import React, { useState } from 'react';
import { AI_FEATURES, AI_SECTION } from '../constants';
import { useLanguage } from '../LanguageContext';
import AIModal from '../components/AIModal';

export default function AISection() {
  const { lang }     = useLanguage();
  const features     = AI_FEATURES[lang];
  const section      = AI_SECTION[lang];
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section
      className="pb-section pb-section-pad"
      id="ia"
      style={{ background: 'var(--pb-bg-subtle)' }}
      data-testid="pb-ai-section"
    >
      <div className="pb-container">
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 24, marginBottom: 0 }}>
          <div>
            <div className="pb-label">{section.label}</div>
            <h2 className="pb-section-title">
              {section.title.split('\n').map((line, i) => (
                <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
              ))}
            </h2>
            <p className="pb-section-sub" style={{ marginTop: 16 }}>{section.sub}</p>
          </div>
        </div>

        {/* Grid */}
        <div className="pb-ai-grid">
          {features.map(feat => (
            <div key={feat.num} className="pb-ai-card" data-testid={`pb-ai-feature-${feat.num}`}>
              <div className="pb-ai-card-num">{feat.num}</div>
              <div className="pb-ai-card-title">{feat.title}</div>
              <p className="pb-ai-card-desc">{feat.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA strip */}
        <div style={{
          marginTop: 40, padding: '28px 32px',
          background: 'var(--pb-deep-blue)', borderRadius: 14,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 20,
        }}>
          <div>
            <div style={{ fontSize: 17, fontWeight: 600, color: 'white', fontFamily: 'Outfit, sans-serif', marginBottom: 4 }}>
              {section.compatText}
            </div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)' }}>
              {section.customText}
            </div>
          </div>
          <button
            className="pb-btn-outline"
            style={{ borderColor: 'rgba(255,255,255,0.2)', color: 'white', fontSize: 14, padding: '9px 20px' }}
            onClick={() => setModalOpen(true)}
            data-testid="pb-ai-cta"
          >
            {section.learnMore}
          </button>
        </div>
      </div>

      <AIModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
}
